export enum TypeCreateBy {
  //Go to Member Home page
  RegistrationPage = 'RegistrationPage',
  //Go to Member Home page or Admin Dashboard page
  AdminMember = 'AdminMember',
  //Go to Care Plans - open shared event page
  Collaboration = 'Collaboration',
}
